import React, { useState } from 'react';
import '../styles/DriverCheckin.css';
import logo from '../images/logo.png';

function DriverCheckin() {
  const [showGateModal, setShowGateModal] = useState(false);
  const [currentGate, setCurrentGate] = useState(1);
  
  // Danh sách cổng
  const gates = Array.from({length: 10}, (_, i) => i + 1);

  // Dữ liệu nhân viên đang phục vụ
  const [currentServing] = useState({
    id: 'NV001',
    number: 125,
    name: 'Nguyễn Văn A',
    phone: '0912345678',
    idCard: '001301123456',
    birthDate: '15/5/1990',
    avatar: logo
  });

  // Danh sách nhân viên chờ
  const [waitingStaff] = useState([
    {
      id: 'NV002',
      name: 'Trần Thị B',
      position: 'Giao dịch viên',
      status: 'Có sẵn'
    },
    {
      id: 'NV003',
      name: 'Lê Văn C',
      position: 'Giao dịch viên',
      status: 'Có sẵn'
    }
  ]);

  // Danh sách nhân viên đã phục vụ
  const [servedStaff] = useState([
    {
      id: 'NV004',
      name: 'Phạm Thị D',
      position: 'Giao dịch viên',
      servedCount: 15
    },
    {
      id: 'NV005',
      name: 'Hoàng Văn E',
      position: 'Giao dịch viên',
      servedCount: 12
    }
  ]);

  const handleReset = () => {
    // Xử lý logic reset ở đây
    console.log('Reset clicked');
  };

  const handleGateChange = (gateNumber) => {
    setCurrentGate(gateNumber);
    setShowGateModal(false);
  };

  return (
    <div className="driver-checkin-container">
      <div className="main-header">
        <h1>HỆ THỐNG XẾP HÀNG TỰ ĐỘNG</h1>
        <button 
          className="gate-button"
          onClick={() => setShowGateModal(true)}
        >
          Cửa số {currentGate}
        </button>
      </div>

      {/* Modal chọn cổng */}
      {showGateModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Chọn cửa số</h2>
            <div className="gate-list">
              {gates.map((gate) => (
                <button
                  key={gate}
                  className={`gate-option ${gate === currentGate ? 'active' : ''}`}
                  onClick={() => handleGateChange(gate)}
                >
                  Cửa số {gate}
                </button>
              ))}
            </div>
            <button 
              className="close-modal"
              onClick={() => setShowGateModal(false)}
            >
              Đóng
            </button>
          </div>
        </div>
      )}

      <div className="content-grid">
        {/* Thông tin nhân viên */}
        <div className="staff-info-section">
          <div className="service-card">
            <h2>Thông tin nhân viên</h2>
            <div className="current-serving">
              <div className="staff-basic-info">
                <img src={currentServing.avatar} alt="Avatar" className="avatar" />
                <div className="number">{currentServing.number}</div>
              </div>
              <div className="driver-info">
                <div className="info-item">
                  <label>Mã NV</label>
                  <span>{currentServing.id}</span>
                </div>
                <div className="info-item">
                  <label>Họ tên</label>
                  <span>{currentServing.name}</span>
                </div>
                <div className="info-item">
                  <label>Số ĐT</label>
                  <span>{currentServing.phone}</span>
                </div>
                <div className="info-item">
                  <label>CCCD</label>
                  <span>{currentServing.idCard}</span>
                </div>
                <div className="info-item">
                  <label>Ngày sinh</label>
                  <span>{currentServing.birthDate}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Nhân viên chờ */}
        <div className="waiting-section">
          <div className="waiting-card">
            <h2>NN VIÊN CHỜ ({waitingStaff.length})</h2>
            <div className="waiting-list">
              {waitingStaff.map((staff) => (
                <div key={staff.id} className="waiting-item">
                  <div className="status-dot yellow"></div>
                  <div className="info">
                    <h3>{staff.name}</h3>
                    <p className="staff-id">{staff.id}</p>
                    <p className="position">{staff.position}</p>
                    <p className="status">{staff.status}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Nhân viên đã phục vụ */}
        <div className="served-section">
          <div className="served-card">
            <h2>ĐÃ PHỤC VỤ ({servedStaff.length})</h2>
            <div className="served-list">
              {servedStaff.map((staff) => (
                <div key={staff.id} className="served-item">
                  <div className="status-dot green"></div>
                  <div className="info">
                    <h3>{staff.name}</h3>
                    <p className="staff-id">{staff.id}</p>
                    <p className="position">{staff.position}</p>
                    <p className="status">Đã phục vụ: {staff.servedCount} khách</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DriverCheckin; 